import { render, staticRenderFns } from "./canvasLock.vue?vue&type=template&id=1c9579fc"
import script from "./canvasLock.vue?vue&type=script&lang=js"
export * from "./canvasLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports